import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
 * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;

    font-family: 'Shantell Sans', cursive;
  

  }

  button:active{
    transform:scale(0.98)
  }
`;
